export const Faculties = [
    {
        "name":"Faculty of Administration",
        "departments": ["Internation Relations", "Local Government and Development Studies", "Management and Accounting", "Public Administration"]
    },
    {
        "name": "Faculty of Agriculture",
        "departments": ["Agricultural Economics", "Agricultural Extension and Rural Development", "Animal Science", "Crop Production and Protection", 
                        "Family, Nutriction & Customer Sciences","Plant Science", "Soil Science"]
    },
    {
        "name": "Faculty of Art",
        "departments": ["Linguistics and African Languages", "Dramatic Arts", "English", "History", "Music", "Philosophy", "Religious Studies"]
    },
    {
        "name": "Faculty of Education",
        "departments": ["Adult Education and Lifelong Learning", "Arts and Social Sciences Education", "Educational Foundation and Counseling", 
                        "Science and Technology Education", "Physical and Health Education"]
    },
    {
        "name": "Faculty of Environmental Design & Management",
        "departments": ["Architecture", "Building", "Estate Management", "Fine and Applied Arts", "Quantity Surveying", "Planning"]
    },
    {
        "name": "Faculty of Basic Medical Science",
        "departments": ["Anatomy and Cell Biology", "Chemical Pathology", "Haemotology and Immunology", "Medical Microbiology and Parasitology",
                        "Medical Rehabilitation", "Medical Biochemistry", "Medical Pharmacology and Therapeutics", "Nursing Science", "Physiological Sciences"]
    },
    {
        "name": "Faculty of Clinical Sciences",
        "departments": ["Anaesthesia", "Community Health", "Dermatology and Venereology", "Medicine", "Mental Health", "Obstertics, Gynaecology and Perinatology", 
                        "Ophthalmology", "Orthopaedics and Traumatology", "Paediatrics and Child Health", "Radiology", "Surgery"]
    },
    {
        "name": "Faculty of Dentistry",
        "departments": ["Child Dental Health", "Oral and Maxillofacial", "Surgery and Oral", "Pathology", "Preventive and Community Dentistry", "Restorative Dentistry"]
    },
    {
        "name": "Faculty of Law",
        "departments": ["Business Law", "International Law", "Jurisprudence and Private Law", "Public Law"]
    },
    {
        "name": "Faculty of Pharmacy",
        "departments": ["Clinical Pharmacy and Pharmacy Administration", "Drug Research and Production Unit", "Pharmaceutical Chemistry", "Pharmacy Pharmacognosy", "Pharmacology"]
    },
    {
        "name": "Faculty of Sciences",
        "departments": ["Biochemistry", "Botany", "Chemistry", "Geology", "Mathematics", "Microbiology", "Physics", "Zoology"]
    },
    {
        "name": "Faculty of Technology",
        "departments": ["Chemical Engineering", "Civil Engineering", "Computer Science and Engineering", "Electronic and Electrical Engineering", "Food Science and Technology", "Mechanical Engineering",
                        "Material Science & Engineering", "Agricultural and Environmental Engineering"]
    },
    {
        "name": "Faculty of Social Sciences",
        "departments": ["Demography and Social Statistics", "Economics", "Geography", "Political Science", "Psychology", "Sociology and Anthropology"]
    },
]